import { Convert } from '@itus/ui.common'

export class RiskAnalysisFailureModeModel {
  constructor(data) {
    data = data || {}
    this.id = Convert.toString(data.id, null)
    this.probabilityValue = Convert.toFloat(data.probabilityValue, null)
  }
}
export default { RiskAnalysisFailureModeModel }
